import { evalES } from '../lib/utils'
import { ToolApplyRequest } from '../types/general-types'

export async function getIncomingVelocity() {
    let incomingVelocity = await evalES(`getIncomingVelocity()`)
    return incomingVelocity[0]
}

export async function readKeyframePairEasingRequest() {
    let keyframePairEasing = await evalES(`readKeyframePairEasing()`)
    return keyframePairEasing
}

export async function clearKeyframeEasingRequest() {
    let keyframePairEasing = await evalES(`clearKeyframeEasing()`)
    return keyframePairEasing
}

export async function loadFavoritePresets() {
    let favoritePresets = await evalES(`loadFavoritePresets()`)
    return favoritePresets
}

export async function saveFavoritePresets(presets: any) {
    let presetsString = JSON.stringify(presets)
    let favoritePresets = await evalES(`saveFavoritePresets(${presetsString})`)
    return favoritePresets
}

export async function loadCustomPresets() {
    let customPresets = await evalES(`loadCustomPresets()`)
    return customPresets
}

export async function saveCustomPresets(presets: any) {
    let presetsString = JSON.stringify(presets)
    let customPresets = await evalES(`saveCustomPresets(${presetsString})`)
    return customPresets
}

export async function loadPresetOrdering(tool: string) {
    let toolString = JSON.stringify(tool)
    let presetOrdering = await evalES(`loadPresetOrdering(${toolString})`)
    return presetOrdering
}

export async function savePresetOrdering(value: string[], tool: string) {
    let orderingString = JSON.stringify(value)
    let toolString = JSON.stringify(tool)
    let presetOrdering = await evalES(`savePresetOrdering(${orderingString}, ${toolString})`)
    return presetOrdering
}

export async function applyTool(req: ToolApplyRequest) {
    let reqString = JSON.stringify(req)
    let result = await evalES(`applyToolES(${reqString})`)
    return result
}